import React, { useState } from 'react';
import firebase from 'firebase';
import {
  TextField,
  Button,
  LinearProgress,
  Collapse
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Layout from '../../Layout';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  const errorMessages = {
    "auth/invalid-email": "O e-mail informado não é válido",
    "auth/user-disabled": "O usuário está desabilitado",
    "auth/user-not-found": "Este usuário não foi encontrado",
    "auth/wrong-password": "A senha informada está incorreta",
  }

  const submit = e => {
    e.preventDefault();
    
    setError('');
    setLoading(true);
    firebase.auth().signInWithEmailAndPassword(email, password)
      .catch(error => {
        const errorCode = error.code;
        setError(errorCode);
      }).then(() => {
        setLoading(false);
      });
  };

  return <Layout dashboard>
    <form
      style={{
        width: '100%',
        maxWidth: 400
      }}
      onSubmit={submit}
    >
      <TextField
        label="E-mail"
        type="email"
        variant="outlined"
        margin="normal"
        name="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        fullWidth
        disabled={loading}
        style={{
          marginBottom: loading && 0
        }}
        inputProps={{
          autoComplete: "off",
          autoFocus: true
        }}
      />
      {
        loading && (
          <LinearProgress style={{
            borderRadius: 1,
            height: 2,
            margin: '11px 0'
          }} />
        )
      }
      <TextField
        label="Senha"
        type="password"
        variant="outlined"
        margin="normal"
        name="password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        fullWidth
        disabled={loading}
        style={{
          marginTop: loading && 0
        }}
        inputProps={{
          autoComplete: "off"
        }}
      />
      <Collapse in={error}>
        <Alert severity="error">{errorMessages[error]}</Alert>
      </Collapse>
      <Button type="submit" disabled={loading} color="primary" variant="contained" style={{ marginTop: 14 }}>
        {
          loading ? 'Processando...' : 'Entrar'
        }
      </Button>
    </form>
  </Layout>
}

export default Login;